(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskBulkUpdateConfirmation',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.task-details').off().on('click', _openTaskDetails);
	};

	function _openTaskDetails(e)
	{
		var $anchor_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.openTaskDetails($anchor_elem);
	}
}(jQuery, window.Adzuki || {}));
